import angular from 'angular';

export type IRotatividadeTotal = { quantidade: number, valor: number | string | null };

export type IRotatividadeGrupo = {
    nivel: 'estabelecimento' | 'lotacao' | 'cargo' | null,
    rotulo: string | null,
    nome: string | null,
    quantidade: number,
    trabalhadores: Array<any>,
    total: IRotatividadeTotal
};

export type IRotatividadeEmpresa = {
    empresa: string,
    nome: string,
    quantidade: number,
    grupos: Array<IRotatividadeGrupo>,
    total: IRotatividadeTotal
};

export type IRotatividadeSecao = { empresas: Array<IRotatividadeEmpresa>, total: IRotatividadeTotal };

export type IRotatividadeAgrupada = {
    agrupamento: 'nenhum' | 'estabelecimento' | 'lotacao' | 'cargo',
    admissoes: IRotatividadeSecao,
    rescisoes: IRotatividadeSecao
};

/**
 * Busca o Relatório de Rotatividade já agrupado (empresa → grupo → colaboradores,
 * com totais). Vem o período inteiro de uma vez: totais por grupo e por empresa
 * dependem de todas as linhas.
 */
export class RotatividadeService {
    static $inject = ['$http', 'nsjRouting', '$q'];

    private cancelamento: angular.IDeferred<void> | null = null;

    constructor(
        public $http: angular.IHttpService,
        public nsjRouting: any,
        public $q: angular.IQService,
    ) { }

    carregarAgrupado(constructors: object): angular.IPromise<IRotatividadeAgrupada> {
        // filtros trocados em sequência: a resposta antiga não pode sobrescrever a nova
        if (this.cancelamento) {
            this.cancelamento.resolve();
        }
        this.cancelamento = this.$q.defer<void>();

        return this.$http.get<IRotatividadeAgrupada>(
            this.nsjRouting.generate('relatoriosliberados_rotatividadeagrupada', constructors, true),
            { timeout: this.cancelamento.promise }
        ).then(response => response.data);
    }
}
